"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESERVE_BUTTON = exports.DEFAULT_COUNTER_MAX_VALUE = exports.COUNTER_MIN_VALUE = exports.BUY_BUTTON_COUNTER = exports.BUY_BUTTON = void 0;
const BUY_BUTTON = exports.BUY_BUTTON = 'buy-button';
const RESERVE_BUTTON = exports.RESERVE_BUTTON = 'reserve-button';
const BUY_BUTTON_COUNTER = exports.BUY_BUTTON_COUNTER = 'buy-button-counter';
const COUNTER_MIN_VALUE = exports.COUNTER_MIN_VALUE = 1;
const DEFAULT_COUNTER_MAX_VALUE = exports.DEFAULT_COUNTER_MAX_VALUE = 99;
